import { Avatar, Button, Divider, Grid, Group, Menu, Paper, Text, Title } from '@mantine/core';
import { showNotification } from '@mantine/notifications';
import moment from 'moment';
import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useApp } from '../../contexts/app.context';
import { GET_ALL_ENTITIES, UPDATE_ENTITY_IMAGE } from '../../services/entities';
import { groupBy, getEntityProfile } from '../../utility/util';
import InputField, { InputFieldTypes } from '../input_field';
import Table from '../table';
import { SAVE_IMAGE } from '../../services/files';

interface ListProps{}
interface ListHandle{
    refresh: () => void;
}

const List : React.ForwardRefRenderFunction<ListHandle, ListProps> = ({}, ref) => {
    const [loading, setLoading] = React.useState(false);
    const [loadingUpdateImage, setLoadingUpdateImage] = React.useState(false);
    const [error, setError] = React.useState<any>(null);
    const [data, setData] = React.useState([]);
    const [filters, setFilters] = React.useState({
        name: "",
        type: ["senador", "deputado_federal"],
        activity: "all",
        company: [],
        profile: [],
        uf: [],
        birthday: [],
    });

    const navigate = useNavigate();

    const loadUsers = () => {
        setError(null);
        setLoading(true);

        GET_ALL_ENTITIES()
        .then(entities => {
            setLoading(false);
            setData(entities);
        })
        .catch(err => {
            setLoading(false);
            setError(err.message);
            showNotification({message: err.message, color: 'red'});
        })
    }

    const saveImage = (id, file) => {
        setLoadingUpdateImage(true)
        
        const formData = new FormData();
        formData.append(`file`, file[0]);
        
        SAVE_IMAGE(formData)
        .then(({url: image}) => {
            UPDATE_ENTITY_IMAGE(id, image)
            .then(() => {
                setLoadingUpdateImage(false)
                loadUsers();
            })
            .catch(err => {
                setLoadingUpdateImage(false)
                showNotification({title: "Ops.", message: err.message, color: 'red'})
            })
        })
        .catch(err => {
            setLoadingUpdateImage(false)
            showNotification({title: "Ops.", message: err.message, color: 'red'})
        })
    }

    const refresh = () => { 
        loadUsers();
    }

    React.useEffect(refresh, []);

    React.useImperativeHandle(ref, () => ({
        refresh: () => { refresh(); }
    }));

    return <>
        <Grid>
            <Grid.Col md={3} sm={12}>
                <Paper
                    style={{
                        cursor: 'pointer',
                        border: !filters.type.includes("orgao") ? '3px solid #228be6' : '3px solid #FFFFFF'
                    }}
                    shadow="md"
                    p="md"
                    onClick={() => setFilters(f => ({...f, type: ["senador", "deputado_federal"]}))}
                >
                    <Text size={24} align="center">Parlamentares</Text>
                </Paper>
            </Grid.Col>
            <Grid.Col md={3} sm={12}>
                <Paper
                    style={{
                        cursor: 'pointer',
                        border: filters.type.includes("orgao") ? '3px solid #228be6' : '3px solid #FFFFFF'
                    }}
                    shadow="md"
                    p="md"
                    onClick={() => setFilters(f => ({...f, type: ["orgao"]}))}
                >
                    <Text size={24} align="center">Comissões</Text>
                </Paper>
            </Grid.Col>
        </Grid>
        <Paper p="sm" mt="md" shadow="sm">
            <Grid mb="xs">
                <Grid.Col md={3} sm={12}>
                    <InputField
                        title="Nome"
                        name="name"
                        value={filters.name}
                        onChange={dt => setFilters(f => ({...f, ...dt}))}
                    />
                </Grid.Col>
                {!filters.type.includes("orgao") && <>
                    <Grid.Col md={2} sm={12}>
                        <InputField
                            title="Perfil"
                            name="profile"
                            type={InputFieldTypes.SELECT}
                            multiple
                            options={[
                                {value: "senador", label: "Senadores"},
                                {value: "deputado_federal", label: "Deputados Federais"},
                            ]}
                            value={filters.profile}
                            onChange={dt => setFilters(f => ({...f, ...dt}))}
                        />
                    </Grid.Col>
                    <Grid.Col md={2} sm={12}>
                        <InputField
                            title="Partido"
                            name="company"
                            type={InputFieldTypes.SELECT}
                            multiple
                            options={groupBy(data, d => d.company)
                                .filter(g => g[0])
                                .sort((a,b) => a[0] > b[0] ? 1 : -1)
                                .map(g => ({value: g[0], label: g[0]}))}
                            value={filters.company}
                            onChange={dt => setFilters(f => ({...f, ...dt}))}
                        />
                    </Grid.Col>
                    <Grid.Col md={2} sm={12}>
                        <InputField
                            title="UF"
                            name="uf"
                            type={InputFieldTypes.SELECT}
                            multiple
                            options={groupBy(data, d => d.uf)
                                .filter(g => g[0])
                                .sort((a,b) => a[0] > b[0] ? 1 : -1)
                                .map(g => ({value: g[0], label: g[0]}))}
                            value={filters.uf}
                            onChange={dt => setFilters(f => ({...f, ...dt}))}
                        />
                    </Grid.Col>
                    <Grid.Col md={3} sm={12}>
                        <InputField
                            title="Aniversário"
                            name="birthday"
                            type={InputFieldTypes.DATERANGE}
                            value={filters.birthday}
                            onChange={dt => setFilters(f => ({...f, ...dt}))}
                        />
                    </Grid.Col>
                    <Grid.Col md={3} sm={12}>
                        <InputField
                            title="Status"
                            name="activity"
                            type={InputFieldTypes.SELECT}
                            value={filters.activity}
                            clearable={false}
                            options={[
                                { label: "Todos", value: "all" },
                                { label: "Em exercício", value: "active" },
                                { label: "Inativos", value: "inactive" },
                            ]}
                            onChange={dt => setFilters(f => ({...f, ...dt}))}
                        />
                    </Grid.Col> 
                </>}
            </Grid>
            {/* <Table 
                data={data
                    .filter(d => 
                        (d.name || "").toLowerCase().includes(filters.name.toLowerCase()) &&
                        (filters.company.length === 0 || filters.company.some(c => (d.company || "").toLowerCase().includes(c.toLowerCase()))) &&
                        (filters.uf.length === 0 || filters.uf.some(c => (d.uf || "").toLowerCase().includes(c.toLowerCase()))) &&
                        (filters.profile.length === 0 || filters.profile.some(p => getEntityProfile(d).toLowerCase().includes(p.toLowerCase())))
                    )
                }
                columns={COLUMNS}
                error={error}
                loading={loading}
                actions={[
                    {title: "Detalhes", onClick: ({ item }) => navigate(`/entidade/${item.id}`)}
                ]}
            /> */}
        </Paper>
        <Grid mt="md">
            {
                data
                .filter(d => 
                    (d.name || "").toLowerCase().includes(filters.name.toLowerCase()) &&
                    (filters.activity === "all" || filters.activity === d.activity) &&
                    (filters.type.length === 0 || filters.type.includes(d.type)) &&
                    (filters.company.length === 0 || filters.company.some(c => (d.company || "").toLowerCase().includes(c.toLowerCase()))) &&
                    (filters.uf.length === 0 || filters.uf.some(c => (d.uf || "").toLowerCase().includes(c.toLowerCase()))) &&
                    (filters.profile.length === 0 || filters.profile.some(p => d.type.includes(p.toLowerCase()))) &&
                    (
                        filters.birthday.length === 0 || 
                        (
                            d.birthday &&
                            (
                                !filters.birthday[0] || 
                                moment(filters.birthday[0]).format("MM-DD") <= moment(d.birthday).format("MM-DD")
                            ) && 
                            (
                                !filters.birthday[1] || 
                                moment(filters.birthday[1]).format("MM-DD") >= moment(d.birthday).format("MM-DD")
                            )
                        )
                    )
                )
                .map(item => (
                    <Grid.Col md={3} sm={12}>
                        <Paper shadow="md" p="sm">
                            {["senador", "deputado_federal"].includes(item.type) && <Group position="center" mb="sm">
                                <Menu>
                                    <Menu.Target>
                                        <Avatar src={item.custom_image ?? item.image} />
                                    </Menu.Target>
                                    <Menu.Dropdown>
                                        <InputField
                                            type={InputFieldTypes.IMAGE}
                                            value={item.custom_image ?? item.image}
                                            name="file"
                                            loading={loadingUpdateImage}
                                            onChange={({file}) => { saveImage(item.id, file); }}
                                        />
                                    </Menu.Dropdown>
                                </Menu>
                            </Group>}
                            <Title align='center' order={5}>{item.name}</Title>
                            {item.type !== "orgao" && <Text weight="bold" color={item.type === "senador" ? "blue" : "green"} align='center' size={13}>{getEntityProfile(item)} - {[item.company, item.uf].filter(nn => nn).join("/")}</Text>}
                            {item.birthday && <>
                                <Divider mt="sm" mb="sm" />
                                <Text align='center' size={13}>Nascimento: {moment(item.birthday).format("DD/MM/YYYY")}</Text>
                            </>}

                            {item.type === 'orgao' && <Group position="right" mt="sm">
                                <Button component={Link} to={`/entidade/${item.id}`}>Detalhes</Button>
                            </Group>}
                        </Paper>
                    </Grid.Col>
                ))
            }
        </Grid>
    </>
}

export default React.forwardRef(List);